<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1167"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1171"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1181"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1179" /></clipPath></defs><g
     id="g1173"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1175"><g
         id="g1177"
         clip-path="url(#clipPath1181)"><g
           id="g1183"
           transform="translate(403.9097,10)"><path
             d="m 0,0 h -364.661 c -13.342,0 -24.249,10.941 -24.249,24.264 V 413 c 0,13.323 10.907,24.264 24.249,24.264 h 27.789"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1185" /></g><g
           id="g1187"
           transform="translate(141.313,64.7642)"><path
             d="m 0,0 h -50.055 c -13.314,0 -24.22,10.913 -24.22,24.264 v 388.708 c 0,13.351 10.906,24.264 24.22,24.264 H 160.136 L 262.597,349.931 V 165.994 M 202.485,0 H 89.77"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1189" /></g><g
           id="g1191"
           transform="translate(403.9097,414.6948)"><path
             d="m 0,0 h -72.688 c -16.374,0 -29.773,13.379 -29.773,29.763 v 57.542"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1193" /></g><g
           id="g1195"
           transform="translate(128.4805,371.4106)"><path
             d="M 0,0 H 213.958"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1197" /></g><g
           id="g1199"
           transform="translate(272.7246,321.0396)"><path
             d="m 0,0 h 69.714 m -213.958,0 h 73.765"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1201" /></g><g
           id="g1203"
           transform="translate(128.4805,270.6689)"><path
             d="M 0,0 H 213.958"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1205" /></g><g
           id="g1207"
           transform="translate(198.9878,220.2983)"><path
             d="M 0,0 H 82.66 M -70.507,0 h 20.141"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1209" /></g><g
           id="g1211"
           transform="translate(128.4805,169.9277)"><path
             d="M 0,0 H 123.168"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1213" /></g><g
           id="g1215"
           transform="translate(128.4805,421.8096)"><path
             d="M 0,0 H 123.338"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1217" /></g><g
           id="g1219"
           transform="translate(392.9468,14.3369)"><path
             d="m 0,0 c -24.135,14.428 -43.766,38.806 -58.893,67.038 -15.24,28.431 -23.512,58.449 -23.257,86.767 0.113,12.557 2.918,13.946 13.342,19.559 l 79.771,43.057 79.77,-43.057 c 10.397,-5.613 13.201,-7.002 13.314,-19.559 C 104.302,125.487 96.031,95.469 80.791,67.038 65.664,38.806 46.033,14.428 21.897,0 12.238,-5.783 9.66,-5.783 0,0 Z"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1221" /></g><g
           id="g1223"
           transform="translate(186.1553,64.7642)"><path
             d="M 0,0 H 0.057"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1225" /></g><g
           id="g1227"
           transform="translate(372.7495,121.853)"><path
             d="M 0,0 20.282,-19.02 62.321,24.151"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1229" /></g></g></g></g></svg>
</template>
